import React, { useEffect, useState } from "react";
import { Navigation } from "lucide-react";
import { reverseGeocode } from "../../lib/reverse_geocode";

/**
 * Per-coord cached address chip. If the entry was created AFTER the
 * backend reverse-geocode landed it already has ``label`` baked in.
 * Otherwise we fall back to a one-shot browser-side lookup against
 * Nominatim — same source the backend uses, just routed directly
 * from the user's device.
 */
export default function GpsChip({ loc, kind, testId }) {
    const [resolved, setResolved] = useState(loc?.label || "");
    useEffect(() => {
        if (loc?.label) { setResolved(loc.label); return; }
        if (loc?.lat == null) return;
        let dead = false;
        reverseGeocode(loc.lat, loc.lng).then((l) => {
            if (!dead && l) setResolved(l);
        });
        return () => { dead = true; };
    }, [loc?.label, loc?.lat, loc?.lng]);
    if (!loc || loc.lat == null) return null;
    const text = resolved || `${(+loc.lat).toFixed(4)}, ${(+loc.lng).toFixed(4)}`;
    const color = kind === "out"
        ? "text-rose-300/80 hover:text-rose-300"
        : "text-emerald-300/80 hover:text-emerald-300";
    return (
        <a
            href={`https://maps.google.com/?q=${loc.lat},${loc.lng}`}
            target="_blank"
            rel="noreferrer"
            title={`${kind === "out" ? "Clock-out" : "Clock-in"} ${(+loc.lat).toFixed(5)}, ${(+loc.lng).toFixed(5)}`}
            className={`flex items-center gap-1 ${color}`}
            data-testid={testId}
        >
            <Navigation className="w-3 h-3" />
            {kind === "out" ? "out " : "in "}{text}
        </a>
    );
}
